module.exports = "https://coursera_assets.s3.amazonaws.com/images/01fa5e6fc2322212ee39ca230d1ebe07.png";